import { Link } from "gatsby"
import React, { useState } from "react"
import { Container } from "react-bootstrap"
import GetGatsbyImage from "../common/site/get-gatsby-image"
import parse from "html-react-parser"
import "./TileBlock.scss"
import { GetPageURL } from "../common/utils"
import PlayVideo from "../PlayVideo/PlayVideo"

const TileBlockModule = ({ module }) => {
  const [isPlay, setPlay] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false)

  const truncateDescription = (text, wordLimit) => {
    const words = text.split(" ");
    if (words.length <= wordLimit) return text; 
    return words.slice(0, wordLimit).join(" ") + "..."; 
  }
const isReadMore = (text, wordLimit) => {
  if (!text) return false;  
  const words = text.split(" "); 
  return words.length > wordLimit;
}

  const toggleDescription = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <div className="tile-block-module-wrapper section-p">
      <Container
        className={`tile-block-container ${
          module.layout_type === "right_content_left_image" ? "" : "img-right"
        }`}
      >
        <div className="img-block rounded">
          {module.media_block &&
            <GetGatsbyImage
              image={module.media_block?.media_file}
              fallbackalt={module.text_block?.title}
            />
          }

          {module.image_tag && <div className="tag">{module.image_tag}</div>}
          {module.video_url && (
            <a
              className="btn-play icon icon-play-white"
              onClick={() => setPlay(true)}
            ></a>
          )}
        </div>
        <div className="content">
          <h3 className="title">{module.text_block?.title}</h3>
          {module.text_block?.description && (
            <div className="description">
              {parse(
                isExpanded
                  ? module.text_block?.description
                  : truncateDescription(module.text_block?.description, 150)
              )}
            </div>
          )}
          {isReadMore(module.text_block?.description, 150) && (
            <button onClick={toggleDescription} className="read-more-btn">
              {isExpanded ? "Read Less" : "Read More"}
            </button>
          )}
          {module.Button_CTA && (
            <Link
              target={module.Button_CTA?.target === "new_window" ? "_blank" : ""}
              target={module.Button_CTA?.target === "new_window" ? "_blank" : ""}
              to={GetPageURL(module.Button_CTA?.menu_item)}
              className="cta-link"
            >
              {module.Button_CTA?.label}
            </Link>
          )}
        </div>
      </Container>
      {isPlay && (
        <PlayVideo
          isOpen={isPlay}
          stopPlay={setPlay}
          videoId=""
          isCloseFunction={setPlay}
          videourl={module.video_url}
          htmlink={""}
        />
      )}
    </div>
  )
}

export default TileBlockModule
